import React from "react";
import { WorkspaceSignalItemRowContainer } from "./WorkspaceSignalItemRowContainer";
import { graphql, useFragment } from "react-relay";
import { WorkspaceSignalListItem_signal$key } from "./__generated__/WorkspaceSignalListItem_signal.graphql";
import { AHIcon, AHText, Box, ListItem, TodoPrioIcon } from "arkh";

import { WorkspaceSignalListItemDescription } from "./WorkspaceSignalListItemDescription";
import { WorkspaceTodoDetailIndicator } from "../WorkspaceTodos/DraftIndicator";
import { FormattedDateInWorkspace } from "../../../common/dates/FormattedDate";

export function WorkspaceSignalListItem(props: {
  workspaceSignal: WorkspaceSignalListItem_signal$key;
  isLast: boolean;
  onPressEdit: (signalWorkspaceId: string) => void;
  onPress: (signalWorkspaceId: string) => void;
  showTopics: boolean;
}) {
  const workspaceSignal = useFragment(
    graphql`
      fragment WorkspaceSignalListItem_signal on SignalWorkspace {
        id
        isWorkspaceOwner(workspaceId: $workspaceId)
        publishedAtDate {
          ...FormattedDate
        }
        scheduledPublishAt {
          ...FormattedDate
        }
        status
        priority
        topic {
          name
        }

        ...WorkspaceSignalListItemDescription_signal
      }
    `,
    props.workspaceSignal
  );
  return (
    <ListItem
      displayMode="TABLE"
      border="border-primary"
      onPress={() => {
        if (
          workspaceSignal.status === "DRAFT" ||
          workspaceSignal.status === "SCHEDULED"
        ) {
          props.onPressEdit(workspaceSignal.id);
        } else {
          props.onPress(workspaceSignal.id);
        }
      }}
      isLast={props.isLast}
    >
      <WorkspaceSignalItemRowContainer
        priority={<TodoPrioIcon priority={workspaceSignal.priority} />}
        description={
          <WorkspaceSignalListItemDescription
            workspaceSignal={workspaceSignal}
          />
        }
        published={
          workspaceSignal.status === "DRAFT" ||
          workspaceSignal.status === "SCHEDULED" ? (
            <Box style={{ flexDirection: "column" }}>
              <WorkspaceTodoDetailIndicator status={workspaceSignal.status} />
              {workspaceSignal.status === "SCHEDULED" &&
              workspaceSignal.scheduledPublishAt ? (
                <AHText spaceTop="xxsmall" type="detail" color="text-secondary">
                  <FormattedDateInWorkspace
                    date={workspaceSignal.scheduledPublishAt}
                  />
                </AHText>
              ) : null}
            </Box>
          ) : (
            <AHText numberOfLines={1}>
              {workspaceSignal.publishedAtDate ? (
                <FormattedDateInWorkspace
                  date={workspaceSignal.publishedAtDate}
                />
              ) : null}
            </AHText>
          )
        }
        topic={
          props.showTopics ? (
            <AHText numberOfLines={1}>
              {workspaceSignal.topic?.name ?? ""}
            </AHText>
          ) : null
        }
        more={
          workspaceSignal.isWorkspaceOwner ? null : (
            <AHIcon type="locked" color="darkText" size="xsmall" />
          )
        }
      />
    </ListItem>
  );
}

/*



          */

/*

 workspaceSignal.status === "DRAFT" ? (
            <DraftIndicator />
          ) : (
            <AHText numberOfLines={1}>
              {workspaceSignal.publishedAtDate ? (
                <FormattedDateInWorkspace
                  date={workspaceSignal.publishedAtDate}
                />
              ) : null}
            </AHText>
          )
        */
